import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  modalaccount: [],
};

export const modalAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_MODALACCOUNTS:
      return {
        ...state,
        modalaccount: action.payload,
      };
    default:
      return state;
  }
};
